export default __webpack_public_path__ + "static/media/pitchpot.b1d7dd04.png";